<template>
  <div class="modal-wrapper" v-if="isOpen">
    <div class="modal" :class="{open: isOpen, fixedHeader: fixedHeader}">
      <div class="modal__inner">
        <div class="modal__close" @click="toggle(false)"><i aria-hidden="true" class="fa fa-times fa-3x"></i></div>
        <header class="modal__header" v-if="title"><h3 v-html="title"></h3></header>
        <section class="modal__content" :class="{ 'no-title': !title }">
          <slot></slot>
        </section>
      </div>
    </div>
    <div class="modal--overlay" v-if="isOpen" @click="toggle(false)"></div>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      fixedHeader: {
        type: Boolean,
        default: false,
      },
      open: Boolean,
    },
    data() {
      return {
        isOpen: false,
      };
    },
    methods: {
      toggle(newState = null) {
        if (newState === null) {

          this.isOpen = !this.isOpen;
        } else {
          this.isOpen = newState;
        }
        this.$emit('onToggle', this.isOpen);
      },
      closeModalWithEsc(e) {
        if (e.keyCode === 27 && this.isOpen) {
          this.isOpen = false;
        }
      }
    },
    created() {
      document.addEventListener('keydown', this.closeModalWithEsc);
    },
    destroyed() {
      document.removeEventListener('keydown', this.closeModalWithEsc);
    },
    mounted() {
      this.isOpen = this.open;
    },
    watch: {
      open(newValue) {

        this.toggle(newValue);
      },
      // prevent body scroll
      isOpen: function (isOpen) {
        if (isOpen) {
          document.documentElement.style.overflow = 'hidden'
          // document.documentElement is the same as using document.querySelector('#root')
        } else {
          document.documentElement.style.overflow = 'auto'
        }
      }

    },
  }
</script>

<style lang="scss">

  $modal-header-height: 135px;
  $modal-header-height-sm: 60px;
  $modal-offset-y: 75px;

  .modal-wrapper {
    position: fixed;
    @include size(100vw, 100vh);
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;
    z-index: 5000;
    .modal {
      margin: 75px auto;
      h3 {
        margin: 0px;
        padding: 0px;
      }
      @include keyframes(modal-show) {
        0% {
          opacity: 0;
          transform: scaleX(0.7) translateY(30px);
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
      transform: translateY(0);
      opacity: 1;
      animation: modal-show 0.3s;
      position: relative;
      z-index: 9000;
      pointer-events: all;
      max-width: 1100px;
      max-height: calc(100vh - #{$modal-offset-y * 2});
      overflow-y: auto;

      @media (max-width: 600px) {
        margin: 0 auto;
        max-height: 100vh;
      }
      &.open {
        transform: none;
        opacity: 1;
        pointer-events: all;
      }
      &__inner {
        background: $color-white;
        position: relative;
        padding: 0 80px;
        @media(max-width: 900px) {
          padding: 0 55px;
        }
        @media(max-width: 700px) {
          padding: 0 15px;
        }
      }
      &__header {
        padding: 20px 30px;
        @media(max-width: 600px) {
          padding: 20px 0;
        }
        h2 {
          padding: 0;
        }
        & + .modal__content {
          padding-top: 0;
        }
      }
      &__content {
        padding: 50px 0;
        @media (max-width: 600px) {
          padding-bottom: 0;
        }
        &.no-title {
          padding-top: 0;
          .modal-section:first-child {
            border-top: none !important;
          }
        }
      }
      &__close {
        cursor: pointer;
        position: absolute;
        right: 40px;
        top: 20px;
        -webkit-text-stroke: 8px white;
       // @include size(25px);
       // @include background-contain('/images/ui/select-close.svg');
        @media(max-width: 600px) {
          right: 15px;
        }
      }
      &.fixedHeader {
        height: calc(100vh - #{$modal-offset-y * 2});
        background: $color-white;
        @media (max-width: 600px) {
          height: 100vh;
        }
        .modal__header {
          height: $modal-header-height;
          box-sizing: border-box;
          @media(max-width: 600px) {
            height: 60px;
          }
        }
        .modal__content {
          position: absolute;
          top: $modal-header-height;
          width: calc(100% - 40px - 40px);
          height: calc(100vh - #{$modal-header-height} - #{$modal-offset-y * 2} - 50px); // 50px - bottom offset
          left: 40px;
          overflow-y: auto;
          .modal-section {
            padding-left: 70px;
            padding-right: 70px;
          }
          @media(max-width: 700px) {
            left: 15px;
            width: calc(100% - 15px - 15px);
            .modal-section {
              padding-left: 30px;
              padding-right: 30px;
            }
          }
          @media(max-width: 600px) {
            top: 60px;
            height: calc(100vh - #{$modal-header-height-sm});
            .modal-section {
              padding-left: 0;
              padding-right: 0;
            }
          }
        }
      }
    }
    .modal--overlay {
      position: absolute;
      @include size(100%);
      top: 0;
      left: 0;
      overflow: scroll;
      z-index: -1;
      background: fade_out($color-black, 0.3);
      pointer-events: all;
      @include keyframes(modal-overlay-show) {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      opacity: 1;
      animation: modal-overlay-show 0.3s;
    }

    // Modal content
    .modal-section {
      padding: 45px 30px;
      border-top: 4px solid $color-text;
      @media (max-width: 600px) {
        padding: 25px 0;
      }
      h2 {
        max-width: 400px;
        padding-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/Modal.vue